import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { filter } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class UrlCleanupService {
    constructor(private router: Router) {
        this.init();
    }

    private init(): void {
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe(() => {
                this.cleanupUrl();
            });
    }

    private cleanupUrl(): void {
        const url = new URL(window.location.href);

        if (url.searchParams.has('iss')) {
            url.searchParams.delete('iss');

            // Use history.replaceState to update the URL without navigation
            window.history.replaceState({}, document.title, url.toString());
        }
    }
}
